export function toggleFocus(system, panel) {
  if (panel.classList.contains('focused')) {
    exitFocus(system);
  } else {
    enterFocus(system, panel);
  }
}

export function enterFocus(system, panel) {
  if (system.isMobileLayout()) return;

  // Only one panel can be focused at a time.
  exitFocus(system);

  // Restore a minimized panel so it is actually visible when focused.
  if (panel.classList.contains('minimized')) system.toggleMinimize(panel);

  // Clear any drag offset so the CSS-centered popup is not shifted.
  panel.style.transform = '';

  let backdrop = document.getElementById('focus-backdrop');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.id = 'focus-backdrop';
    backdrop.className = 'focus-backdrop';
    backdrop.addEventListener('click', () => exitFocus(system));
    document.body.appendChild(backdrop);
  }
  void backdrop.offsetWidth;
  backdrop.classList.add('active');

  document.body.classList.add('focus-active');
  panel.classList.add('focused');
  system.focusedPanel = panel;

  const btn = panel.querySelector('.focus-btn');
  if (btn) {
    btn.classList.add('active');
    btn.setAttribute('aria-label', 'Exit Focus Mode');
    btn.setAttribute('title', 'Exit Focus Mode');
  }

  if (!system._focusKeyHandler) {
    system._focusKeyHandler = (e) => {
      if (e.key === 'Escape') exitFocus(system);
    };
    document.addEventListener('keydown', system._focusKeyHandler);
  }
}

export function exitFocus(system) {
  const panel = system.focusedPanel || document.querySelector('.panel.focused');
  if (panel) {
    panel.classList.remove('focused');
    const btn = panel.querySelector('.focus-btn');
    if (btn) {
      btn.classList.remove('active');
      btn.setAttribute('aria-label', 'Focus Mode');
      btn.setAttribute('title', 'Focus Mode');
    }
  }
  const backdrop = document.getElementById('focus-backdrop');
  if (backdrop) backdrop.remove();
  document.body.classList.remove('focus-active');
  system.focusedPanel = null;

  if (system._focusKeyHandler) {
    document.removeEventListener('keydown', system._focusKeyHandler);
    system._focusKeyHandler = null;
  }
}
